<div class="avatar text-center text-white font-semi-bold avatar-{{ size }}">{{ initials }}</div>
